import React from "react";


const Footer = () => {
  return (
    <footer id="colophon" className="clearfix ">
    <div className="footer-widgets-wrapper">
      <div className="inner-wrap">
        <div className="footer-widgets-area clearfix">
          <div className="tg-footer-main-widget">
            <div className="tg-first-footer-widget">
              <aside id="text-3" className="widget widget_text clearfix">
                <h3 className="widget-title"><span>“সংশয় – চিন্তার মুক্তির আন্দোলন” – সম্পর্কে</span></h3>
                <div className="textwidget">
                  <p>“সংশয় – চিন্তার মুক্তির আন্দোলন” একটি অলাভজনক ওয়েবসাইট। এই ওয়েবসাইটের সকল লেখা কপিরাইট মুক্ত, শুধুমাত্র আমাদের ওয়েবসাইট এবং মূল লেখকের নাম যুক্ত করার শর্তে। শুধুমাত্র পাঠকদের বুদ্ধিবৃত্তিক বিতর্ক এবং আলোচনাকে উৎসাহিত করার উদ্দেশ্যে তৈরি করা। বাঙলাদেশ সরকার কর্তৃক ইতিমধ্যে আমাদের অনেক লেখক এবং গোটা ওয়েবসাইটই নিষিদ্ধ ঘোষিত হয়েছে। যা আমাদের জন্য গর্বের, সম্মানের এবং আনন্দের। অসংখ্য আক্রমণ এবং রাজনৈতিক নির্যাতনের পরেও, জেল জুলুম এবং মামলার পরেও আমরা লিখে যাচ্ছি- সত্য, যুক্তি এবং মুক্তচিন্তা প্রসারের স্বার্থে। আপনাদের সহযোগিতা আমাদের কাম্য। অনুগ্রহ করে ওয়েবসাইটটি বন্ধুদের সাথে শেয়ার করুন। অলাভজনক ওয়েবসাইট হওয়ার কারণে আমাদের সামর্থ্য সীমিত। আপনি কোন ডোনেশন পাঠাতে চাইলে সম্পাদকের কাছে ইমেইল করুন।</p>
                </div>
              </aside>
            </div>
          </div>
          <div className="tg-footer-other-widgets">
            <div className="tg-second-footer-widget">
              <aside id="text-4" className="widget widget_text clearfix">
                <h3 className="widget-title"><span>যোগাযোগ</span></h3>
                <div className="textwidget">
                  <p>লেখা পাঠাবার জন্য আমাদের কাছে একটি লেখা ইমেইল করুন। রেফারেন্সভিত্তিক তথ্যসমৃদ্ধ লেখাই শুধুমাত্র আমরা প্রকাশ করি।<br />
                    <a href="https://shongshoy.com/wp-login.php?action=register">রেজিস্ট্রেশন বা সাবস্ক্রাইব করুন।</a><br />
                    Editor-in-Chief: Asif Mohiuddin <a href="/cdn-cgi/l/email-protection#86efe8e0e9c6f5eee9e8e1f5eee9ffa8e5e9ebb9d5f3e4ece3e5f2bbc7e4e9f3f2a3b4b6d5eee9e8e1f5eee9ff" target="_top" rel="noopener">Send Mail</a><br />
                    Article Editor: Matubbar Azad Avijit <a href="/cdn-cgi/l/email-protection#1c717d68697e7e7d6e5c6f7473727b6f747365327f7371234f697e76797f68215d7e736968392e2c4f7473727b6f747365392e2c5d6e68757f7079" target="_top" rel="noopener">Send Mail</a><br />
                    Rebuttal Editor: Marufur Rahman Khan <a href="/cdn-cgi/l/email-protection#8ee3effcfbe8cefde6e1e0e9fde6e1f7a0ede1e3b1ddfbece4ebedfab3cfece1fbfaabbcbedde6e1e0e9fde6e1f7abbcbedcebecfbfafaefe2" target="_top" rel="noopener">Send Mail</a><br />
                    Science Editor: Dr. Amit <a href="/cdn-cgi/l/email-protection#32535f5b4672415a5d5c55415a5d4b1c515d5f0d614750585751460f73505d4746170002615a5d5c55415a5d4b17000261515b575c5157" target="_top" rel="noopener">Send Mail</a><br />
                    Content Editor: Jack Piter <a href="/cdn-cgi/l/email-protection#325853515972415a5d5c55415a5d4b1c515d5f0d614750585751460f73505d4746170002615a5d5c55415a5d4b170002715d5c46575c46" target="_top" rel="noopener">Send Mail</a>
                  </p>
                </div>
              </aside>
            </div>
            <div className="tg-third-footer-widget">
              <aside id="blog_subscription-10" className="widget widget_blog_subscription jetpack_subscription_widget clearfix">
                <h3 className="widget-title"><span>Subscribe</span></h3>
                <div className="wp-block-jetpack-subscriptions__container">
                  <form action="#" method="post" acceptCharset="utf-8" id="subscribe-blog-blog_subscription-10">
                    <div id="subscribe-text">
                      <p>Enter your email address to subscribe to this blog and receive notifications of new posts by email.</p>
                    </div>
                    <p id="subscribe-email">
                      <label id="jetpack-subscribe-label" className="screen-reader-text" htmlFor="subscribe-field-blog_subscription-10">
                        Email Address </label>
                      <input type="email" name="email" required="required" defaultValue id="subscribe-field-blog_subscription-10" placeholder="Email Address" />
                    </p>
                    <p id="subscribe-submit">
                      <input type="hidden" name="action" defaultValue="subscribe" />
                      <input type="hidden" name="source" defaultValue="https://www.shongshoy.com/" />
                      <input type="hidden" name="sub-type" defaultValue="widget" />
                      <input type="hidden" name="redirect_fragment" defaultValue="subscribe-blog-blog_subscription-10" />
                      <button type="submit" className="wp-block-button__link" name="jetpack_subscriptions_widget">
                        Subscribe </button>
                    </p>
                  </form>
                  <div className="wp-block-jetpack-subscriptions__subscount">
                    Join 20,789 other subscribers 
                  </div>
                </div>
              </aside>
            </div>
            <div className="tg-fourth-footer-widget">
              <aside id="meta-5" className="widget widget_meta clearfix">
                <h3 className="widget-title"><span>প্রবেশদ্বার</span></h3>
                <ul>
                  <li><a rel="nofollow" href="https://www.shongshoy.com/wp-login.php?action=register">নিবন্ধন করুন</a></li>
                  <li><a rel="nofollow" href="https://www.shongshoy.com/wp-login.php">প্রবেশ</a></li>
                  <li><a href="https://www.shongshoy.com/feed/">এন্ট্রি ফিড</a></li>
                  <li><a href="https://www.shongshoy.com/comments/feed/">কমেন্ট ফিড</a></li>
                  <li><a href="https://wordpress.org/%20">WordPress.org</a></li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="footer-socket-wrapper clearfix">
      <div className="inner-wrap">
        <div className="footer-socket-area">
          <div className="footer-socket-right-section">
            <div className="social-links">
              <ul>
                <li><a href="https://www.facebook.com/shongshoydotcom" target="_blank"><i className="fa fa-facebook" /></a></li>
                <li><a href="https://twitter.com/iamasifm" target="_blank"><i className="fa fa-twitter" /></a></li>
                <li><a href="https://www.youtube.com/channel/UCAutFggTjBZJdOnHfGA9nQQ" target="_blank"><i className="fa fa-youtube" /></a></li>
              </ul>
            </div>
          </div>
          <div className="footer-socket-left-section">
            <div className="copyright">Copyright © 2022 <a href="https://www.shongshoy.com/" title="সংশয় – চিন্তার মুক্তির আন্দোলন"><span>সংশয় – চিন্তার মুক্তির আন্দোলন</span></a>. All rights reserved.</div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  );
};
export default Footer;
















// WEBPACK FOOTER //
// ./src/components/footer.js